import { MenuItem } from '@material-ui/core';
import React from 'react';

import useVehicleTypeSelectable from 'core/hooks/useVehicleTypeSelectable';
import { InputField, InputFieldProps } from 'Elements/Form';

export default function VehicleTypeSelect(props: InputFieldProps) {
  const vehicleTypes = useVehicleTypeSelectable();

  return (
    <InputField
      {...props}
      select
      fullWidth
      variant="outlined"
      placeholder="Valitse"
      margin="normal"
      InputLabelProps={{
        shrink: true
      }}
    >
      {vehicleTypes
        .sort((a, b) => a.label.localeCompare(b.label))
        .map(type => (
          <MenuItem key={type.id} value={type.id}>
            {type.label}
          </MenuItem>
        ))}
    </InputField>
  );
}
